<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <v-progress-circular
          :size="90"
          :width="7"
          indeterminate
          color="#93BA1F"/>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Loading'
}
</script>

<style lang="scss">
  .modal-mask {
    position: fixed;
    z-index: 998;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background-color: rgba(0, 0, 0, 0.6);
    display: table;
    transition: opacity 0.3s ease;
  }

  .modal-wrapper {
    text-align: center;
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    border-radius: 0.5em !important;
    width: 500px;
    margin: 0px auto;
    padding: 20px 30px;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
    margin-top: 0;
  }

  .modal-body {
    margin: 20px 0;
    padding: 0 0;
  }

  .modal-default-button {
    float: right;
  }

  .modal-enter,
  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .modal-footer {
    padding-bottom: 0;
  }
</style>
